import { InventoryReturnRequest, Order, OrderProduct } from '../../../../../../clients/quipli-service/order/order';
import { CalculateOverageChargeResult } from '../../../../../../clients/quipli-service/product/product';
import { HourOverageOverride } from '../../../shared/hooks/use-hour-overage-calculation';
import { FuelCharge } from '../../../shared/types/fuel-charge-types';
import { FinancialSummary } from '../../../../../../clients/quipli-service/financials/financials';
import { InventoryReturnHourInput } from '../../../inventory-return';
import { InventoryReturnFuelChargeInput } from '../../../shared/components/inventory-return-fuel-charge-input';
import { computeFuelCharge } from '../../../shared/utils/fuel-charge-utils';

export const OffRentUnitRow = ({
  order,
  orderProduct,
  isSelectedForReturn,
  inventoryReturnRequest,
  unitTrackingType,
  setInventoryReturnRequest,
  getOverageForUnit,
  getOverrideForUnit,
  updateOverageOverride,
  getFuelChargeForUnit,
  updateFuelCharge,
  existingSummary,
  fuelCharges,
  currency,
  isCalculating,
}: {
  order: Order;
  orderProduct: OrderProduct;
  isSelectedForReturn: boolean | undefined;
  inventoryReturnRequest: InventoryReturnRequest | undefined;
  unitTrackingType: 'serialNumber' | 'unitNumber';
  setInventoryReturnRequest: React.Dispatch<React.SetStateAction<InventoryReturnRequest | undefined>>;
  getOverageForUnit: (orderProductId: number, unitId: number) => CalculateOverageChargeResult | undefined;
  getOverrideForUnit: (orderProductId: number, unitId: number) => HourOverageOverride | undefined;
  updateOverageOverride: (orderProductId: number, unitId: number, value: HourOverageOverride) => void;
  getFuelChargeForUnit: (orderProductId: number, unitId: number) => FuelCharge | undefined;
  updateFuelCharge: (orderProductId: number, unitId: number, updates: { amount: number; productId?: number }) => void;
  existingSummary: FinancialSummary | undefined;
  fuelCharges: FuelCharge[];
  currency: Dinero.Currency | undefined;
  isCalculating: boolean;
}) => {
  return (
    <>
      {/* --------------- row break - start inventory units' rows -------------- */}
      {orderProduct.assignedUnits.map((au) => {
        return (
          <>
            <div className={`ml-4 col-span-6`}>
              <div>Unit {au[unitTrackingType]}</div>
            </div>

            {/*  ---------------------- row break ---------------- */}
            {isSelectedForReturn && inventoryReturnRequest && orderProduct.product.allowHourTracking ? (
              <>
                <div></div>
                <InventoryReturnHourInput
                  readingsDisabled={true}
                  key={au.id}
                  showLabel={true}
                  showUnit={false}
                  labelPosition={'top'}
                  unitTrackingType={unitTrackingType}
                  unit={au}
                  orderProduct={orderProduct}
                  hourReading={inventoryReturnRequest.hourReadings.find((hr) => hr.unitId === au.id)?.hourReading}
                  setHourReading={(hr) =>
                    setInventoryReturnRequest((r) => {
                      return r
                        ? {
                            ...r,
                            hourReadings: [
                              ...r.hourReadings.filter((hr) => hr.unitId !== au.id),
                              { unitId: au.id, hourReading: hr },
                            ],
                          }
                        : undefined;
                    })
                  }
                  overage={getOverageForUnit(orderProduct.id, au.id)}
                  overageOverride={getOverrideForUnit(orderProduct.id, au.id)}
                  setOverageOverride={(value) => updateOverageOverride(orderProduct.id, au.id, value)}
                  isCalculating={isCalculating}
                />
                <div></div>
                {/*  --------- row break ----------- */}
                {orderProduct.product.fuelChargeProductId ? (
                  <>
                    <div className="col-start-2 col-span-3 gap-4 items-center">
                      <InventoryReturnFuelChargeInput
                        readingsDisabled={true}
                        orderProduct={orderProduct}
                        fuelAmount={getFuelChargeForUnit(orderProduct.id, au.id)?.amount}
                        setFuelAmount={(fuelAmount) =>
                          updateFuelCharge(orderProduct.id, au.id, {
                            amount: fuelAmount,
                            productId: orderProduct.product.fuelChargeProductId,
                          })
                        }
                      />
                    </div>
                    <div className="flex flex-col h-full place-content-center">
                      <div className="justify-left" data-cy="fuel-charge-amount">
                        {computeFuelCharge(existingSummary, fuelCharges, currency || 'USD', orderProduct, au)}
                      </div>
                    </div>
                    {order.isCycleBilled && <div className="col-span-2"></div>}
                  </>
                ) : (
                  <></>
                )}
              </>
            ) : (
              <></>
            )}
          </>
        );
      })}
      {/* light grey divider */}
      <div className="col-span-6 border-solid border-[var(--grey-300)]"></div>
      {/* --------row break after each unit ---------- */}
    </>
  );
};
